import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

// Import translation files
import commonEn from "../locales/en/common.json"
import componentsEn from "../locales/en/components.json"
import errorsEn from "../locales/en/errors.json"
import pagesEn from "../locales/en/pages.json"
import validationEn from "../locales/en/validation.json"

import commonFr from "../locales/fr/common.json"
import componentsFr from "../locales/fr/components.json"
import errorsFr from "../locales/fr/errors.json"
import pagesFr from "../locales/fr/pages.json"
import validationFr from "../locales/fr/validation.json"

import commonEs from "../locales/es/common.json"
import componentsEs from "../locales/es/components.json"
import errorsEs from "../locales/es/errors.json"
import pagesEs from "../locales/es/pages.json"
import validationEs from "../locales/es/validation.json"

const resources = {
  en: {
    common: commonEn,
    pages: pagesEn,
    components: componentsEn,
    errors: errorsEn,
    validation: validationEn,
  },
  fr: {
    common: commonFr,
    pages: pagesFr,
    components: componentsFr,
    errors: errorsFr,
    validation: validationFr,
  },
  es: {
    common: commonEs,
    pages: pagesEs,
    components: componentsEs,
    errors: errorsEs,
    validation: validationEs,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    defaultNS: "common",
    ns: ["common", "pages", "components", "errors", "validation"],
    interpolation: {
      escapeValue: false, // React already escapes values
      prefix: "{",
      suffix: "}",
    },
    detection: {
      // Order of detection methods
      // For unauthenticated users: use browser language (navigator) first, then localStorage
      // For authenticated users: user settings will override via useI18n hook
      // Priority: localStorage (user preference) > navigator (browser language) > fallback (en)
      order: ["localStorage", "navigator"],
      // Keys to lookup language from
      lookupLocalStorage: "i18nextLng",
      // Cache user language preference
      caches: ["localStorage"],
    },
    react: {
      useSuspense: false, // Disable suspense to avoid issues
    },
  })

export default i18n
